/**
 * 统一统计卡片组件
 */
import React, { memo } from 'react';

/**
 * 统计卡片组件
 * @param {Object} props
 * @param {string} props.label - 标签文本
 * @param {string|number} props.value - 数值
 * @param {React.ReactNode} props.icon - 图标
 * @param {string} props.color - 主题色 (hex)
 * @param {number} props.trend - 趋势百分比
 * @param {string} props.trendLabel - 趋势标签
 * @param {string} props.suffix - 后缀单位
 */
const StatCard = ({
  label,
  value,
  icon,
  color = '#2563eb',
  trend,
  trendLabel = '较昨日',
  suffix = ''
}) => {
  const trendClass = trend > 0 ? 'up' : trend < 0 ? 'down' : '';
  const trendText = trend > 0 ? '+' : '';

  return (
    <div className="stat-card" style={{ '--stat-color': color }}>
      <div className="stat-card-header">
        <div className="stat-card-icon" style={{ background: `${color}15`, color }}>
          {icon}
        </div>
        {trend !== undefined && trend !== null && (
          <span className={`stat-card-trend ${trendClass}`}>
            {trendText}{trend}% {trendLabel}
          </span>
        )}
      </div>
      <div className="stat-card-value">
        {value}
        {suffix && <span style={{ fontSize: 14, fontWeight: 400, marginLeft: 4 }}>{suffix}</span>}
      </div>
      <div className="stat-card-label">{label}</div>
    </div>
  );
};

export default memo(StatCard);

/**
 * 统计卡片网格组件
 */
export const StatCardGrid = ({ children, columns = 4 }) => {
  const style = {
    '--stat-grid-columns': String(columns)
  };

  return (
    <div className="stat-card-grid" style={style}>
      {children}
    </div>
  );
};
